module.exports = __webpack_public_path__ + "img/hiking004.66e1b786.jpg";